<template>
  <div class="pages" v-loading="listLoading">
    <div
        v-for="(item, index) in templateData.TemplateContent.Controls"
        :key="index"
    >
      <Digit v-if="item.Property.Control == 'Number'" :data-val="item"></Digit>
      <Contact
          v-if="item.Property.Control == 'Condition'"
          :data-val="item"
      ></Contact>
      <Dates v-if="item.Property.Control == 'Date'" :data-val="item"></Dates>
      <Version
          v-if="item.Property.Control == 'Text'"
          @child-event="getTextVal"
          :data-val="item"
      ></Version>
      <Money v-if="item.Property.Control == 'Money'" :data-val="item"></Money>
      <Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
      <File v-if="item.Property.Control == 'File'" :data-val="item"></File>
      <Table
          v-if="item.Property.Control == 'Table'"
          @child-event="tableOperation"
          :data-val="item"
          :template-data="templateData"
      ></Table>
      <Selector
          v-if="item.Property.Control == 'Selector'"
          @child-event="getSelectorVal"
          :data-val="item"
      ></Selector>
      <Textarea
          v-if="item.Property.Control == 'Textarea'"
          :data-val="item"
      ></Textarea>
      <Choose
          v-if="item.Property.Control == 'Contact'"
          @child-event="clickChoose"
          :data-val="item"
      ></Choose>
    </div>

    <Button
        class="submit-process"
        v-on:click="submit"
        v-bind:disabled="isDisabled"
        v-bind:loading="formLoading"
        size="large"
        type="primary"
    >
      提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Dates from "../components/Date.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import SelectFilterTable from "../components/SelectFilterTable.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";

import {initWxConfig} from "../api/jssdk.js";
import {
  getTemplateInfo,
  submitProcess,
  getAdministrativeProgressive,
} from "@/api/approval";
import {
  getAllocationTemplatePagers,
  getTemplateDetail,
  getAllocationTableHeaderDto,
  getFlowsTableDetail,
  isProcessEffective,
  getAllocationTemplateMatchTemplate,
} from "@/api/allocation";
import {
  getDepartmentInfo,
  getDepartmentRelationByStructs,
} from "@/api/department";
import {getRelation, getEmpInfo} from "@/api/employee";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Dates,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
  },
  data() {
    return {
        templateData: template,
        relationList: null,
        logInfo: null,
        templateId: "",
        spNo: null,
        formLoading: false,
        listLoading: false,
        isDisabled: false,
        hierarchyCopy: null,
        deptCopy: null,
        remarksCopy: null,
        id: null,
        fyVal: null,
        status: null,
        fyValKey: null,
        dataType: null,
        PApprova: null,
        res: null,
        Options: null
    };
  },
  created() {
    // stringUtils.setAddIsShow(false);
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    this.dataType = this.$route.query.dataType;
    this.getTemplate();
    //this.getEmployeeRelation(this.logInfo.EmpNo);
  },
  methods: {
    //方法
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg == "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              var user = res.result.userList[0];
              dataVal.Values.push([user.id, user.name]);
              dataVal.Value = `${user.id}-${user.name}`;
              //this.PApprova = { Key: user.id, Value: user.name };
            }
          }
      );
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    getTemplate: async function () {
        //判断是否是IOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            var oDate = new Date();
            oDate.setDate(oDate.getDate() + 7200);
            document.cookie = `logInfo=${encodeURI(JSON.stringify(this.logInfo))};expires=${oDate.toDateString()}`
        }
        var departs = this.logInfo.fullName;
        var empNo = this.logInfo.EmpNo;
       
        //部门名称
        if (this.id == null) {
            var commissionAuth = this.$store.state.secondaryCommissionAuth.commission;
            if (
                !commissionAuth.create.includes(empNo) &&
                this.isDisabled == false
            ) {
                this.Message({
                    message: "没有申请权限",
                    type: "error",
                    duration: 1000,
                });
                this.isDisabled = true;
            }
        } else {
            let processEffective;
            await isProcessEffective(this.id).then(res => {
                processEffective = res.body;
            })
            if (processEffective) {
                this.Message({
                    message: "同一项目不能变更多次",
                    type: "error",
                    duration: 1000,
                });
                this.isDisabled = true;
            }
        }
        this.listLoading = true;
        var title = this.logInfo.fullName;
        var jobLevel = this.logInfo.JobLevel;
        await getTemplateInfo(this.templateId).then(async (response) => {
            var controls = response.Body;
            var cols = controls.TemplateContent.Controls;
            cols.forEach(async (item, index) => {
                if (item.Property.Title[0].Text.indexOf("部门数据填写") > -1) {
                    let childrens = item.Config.Table.Children;
                    item.addIsShow = false;
                    //深拷贝
                    let deptData = JSON.stringify(item);
                    this.deptCopy = JSON.parse(deptData);
                    item.IsShow = false;
                }
            });
            cols.splice(15, cols.length - 15);
            if (this.id != null) {
                let depts = [];
                let that = this;
                await getFlowsTableDetail(this.id).then((res) => {
                    that.res = res;
                });
                var resId = that.res.body.allocationTable.commissionRateTypeId;
                await getAllocationTemplateMatchTemplate(resId).then(res => {
                    this.Options = [];
                    let bodys = res.body;
                    for (let i = 0; i < bodys.length; i++) {
                        let body = bodys[i];
                        this.Options.push({ "Key": body.id, "Value": body.templateName })
                    }
                });
                let alltable = that.res.body.allocationTable;
                if (that.res.body.applicantNo != that.logInfo.EmpNo) {
                    this.Message({
                        message: "没有申请权限",
                        type: "error",
                        duration: 1000,
                    });
                    this.isDisabled = true;
                }
                alltable.headerExtensions.forEach((item) => {
                    depts.push(item);
                });
                cols.forEach(async (col, index) => {
                    if (col.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
                        col.Property.Control = "Selector";
                        this.$set(col, 'IsSeComChange', true)
                        col.clearable = false;
                        col.filterable = true;
                        this.$set(col, 'Options', this.Options)
                        this.$set(col, 'value', {
                            Key: alltable.commissionRateTypeId,
                            Value: alltable.commissionRateType
                        })
                        col.Value = alltable.commissionRateTypeId;
                        this.fyValKey = alltable.commissionRateTypeId;
                    }
                    if (col.Property.Title[0].Text.indexOf("项目名称") > -1) {
                        col.Value = alltable.projectName;
                        col.Disable = true;
                    }
                    if (col.Property.Title[0].Text.indexOf("类别") > -1) {
                        col.Config.Selector.Options.forEach((item) => {
                            if (item.Value[0].Text == alltable.projectType) {
                                col.Value = item.Key;
                            }
                        });
                    }
                    if (col.Property.Title[0].Text.indexOf("是否在以后销售佣金中抵扣") >-1) {
                        if (alltable.laterCommissionDeduction === null) {
                            col.Value = alltable.laterCommissionDeduction;
                        } else {
                            if (!alltable.laterCommissionDeduction) {
                                let ops = col.Config.Selector.Options;
                                ops.forEach((item) => {
                                    if (item.Value[0].Text == "否") {
                                        col.Value = item.Key;
                                    }
                                });
                            } else {
                                let ops = col.Config.Selector.Options;
                                ops.forEach((item) => {
                                    if (item.Value[0].Text == "是") {
                                        col.Value = item.Key;
                                    }
                                });
                            }
                        }
                    }
                    if (col.Property.Title[0].Text.indexOf("开发商名称") > -1) {
                        col.Value = alltable.developersName;
                    }
                    if (col.Property.Title[0].Text.indexOf("对外分佣") > -1) {
                        col.Value = alltable.externalCommission;
                        col.IsShow = true;
                    }
                    if (col.Property.Title[0].Text.indexOf("转介费") > -1) {
                        col.Value = alltable.referralFee;
                        col.IsShow = true;
                    }
                    if (col.Property.Title[0].Text.indexOf("备注") > -1) {
                        col.Value = alltable.remarks;
                        col.IsShow = true;
                    }
                    if (col.Property.Title[0].Text.indexOf("成交编号") > -1) {
                        col.Value = alltable.contractNo;
                    }
                    if (col.Property.Title[0].Text.indexOf("盘源类型") > -1) {
                        col.Value = alltable.buildType === null || alltable.buildType === "" ? '无' : alltable.buildType;
                        col.Disable = true;
                    }
                    if (col.Property.Title[0].Text.indexOf("请选择营运部总经理") > -1) {
                        let papp = alltable.projectApproval;
                        col.Values = [];
                        if (papp !== null) {
                            col.Values.push([papp.key, papp.value]);
                            col.Value = `${papp.key}-${papp.value}`;
                        }
                        col.IsShow = true;
                        this.$set(col, "subCommission", true);
                    }
                    if (col.Property.Title[0].Text.indexOf("代理类型") > -1) {
                        col.Config.Selector.Options.forEach((item) => {
                            if (item.Value[0].Text == alltable.agencyType) {
                                col.Value = item.Key;
                            }
                        });
                    }
                    if (col.Property.Title[0].Text.indexOf("品牌顾问策划项目") > -1) {
                        if (alltable.brandConsultantPlanningProject === null) {
                            col.Value = alltable.brandConsultantPlanningProject;
                        } else {
                            if (!alltable.brandConsultantPlanningProject) {
                                let ops = col.Config.Selector.Options;
                                ops.forEach((item) => {
                                    if (item.Value[0].Text == "否") {
                                        col.Value = item.Key;
                                    }
                                });
                            } else {
                                let ops = col.Config.Selector.Options;
                                ops.forEach((item) => {
                                    if (item.Value[0].Text == "是") {
                                        col.Value = item.Key;
                                    }
                                });
                            }
                        }
                    }
                    if (col.Property.Title[0].Text.indexOf("计佣区域") > -1) {
                        col.Config.Selector.Options.forEach((item) => {
                            if (item.Value[0].Text == alltable.commissionArea) {
                                col.Value = item.Key;
                            }
                        });
                    }
                    if (col.Property.Title[0].Text.indexOf("申请变更日期") > -1) {
                        alltable.applyChangeDate = alltable.applyChangeDate.substring(0,10);
                        col.Value = alltable.applyChangeDate;
                    }
                });
                await getTemplateDetail(this.fyValKey).then((res) => {
                    cols.splice(17, cols.length - 17);
                    let details = res.body.allocationDetails;
                    let deptns = [];
                    let deptP = [];
                    let newDepts = [];
                    depts.forEach((dept) => {
                        if (dept.isMark) {
                            deptns.push(`${dept.key}/${dept.value}`);
                        } else {
                            deptP.push({
                                Key: dept.key.replace("填写人", ""),
                                Value: dept.value,
                            });
                        }
                    });
                    deptns.forEach((dept) => {
                        deptP.forEach((deptp) => {
                            if (dept.split("/")[0] == deptp.Key) {
                                newDepts.push({
                                    key: dept,
                                    value: deptp.Value,
                                });
                            }
                        });
                    });
                    newDepts = newDepts.filter(e => e.value !== null);
                    depts = newDepts;
                    depts.forEach((dept) => {
                        this.deptCopy.Property.Title[0].Text = `${dept.key.split("/")[0]}数据填写`;
                        let childrens = this.deptCopy.Config.Table.Children;
                        childrens.forEach((item) => {
                            if (item.Property.Title[0].Text.indexOf("部门名称") > -1) {
                                item.Value = dept.key.split("/")[1];
                            }
                            if (item.Property.Title[0].Text.indexOf("部门数据填写人") > -1) {
                                item.Values = [];
                                item.Values.push([
                                    dept.value.split("-")[0],
                                    dept.value.split("-")[1],
                                ]);
                                // alert("xxx")
                                // alert(JSON.stringify(item))
                                item.Value = dept.value;
                            }
                        });
                        this.$set(this.deptCopy, "subCommission", true);
                        cols.push(this.deptCopy);
                        let deptData = JSON.stringify(this.deptCopy);
                        this.deptCopy = JSON.parse(deptData);
                    });
                });
            } else {
                cols.forEach(async (item, index) => { 
                    var departs = this.logInfo.fullName.split("/");
                    if (item.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
                        item.Property.Control = "Selector";
                        item.filterable = true;
                        item.Property.Placeholder[0].Text = "请输入内容进行搜索";
                        item.IsSeCom = true;
                        item.IsShow = true;
                    }
                    if (item.Property.Title[0].Text.indexOf("请选择营运部总经理") > -1) {
                        this.$set(item, "subCommission", true);
                    }
                    if (item.Property.Title[0].Text.indexOf("备注") > -1) {
                        item.IsShow = true;
                    }
                    if (item.Property.Title[0].Text.indexOf("分佣信息") > -1) {
                        let childrens = item.Config.Table.Children;
                        childrens.forEach((item) => {
                            if (item.Property.Title[0].Text.indexOf("角色层级") > -1) {
                                item.Disable = true;
                                item.Value = "后台数据";
                            }
                            if (item.Property.Title[0].Text.indexOf("角色计佣比例") > -1) {
                                item.Disable = true;
                                item.Value = "后台数据";
                            }
                            if (item.Property.Title[0].Text.indexOf("部门分佣比例") > -1) {
                                item.Value = "后台数据";
                                item.Disable = true;
                            }
                        });
                        item.addIsShow = false;
                        let hierarData = JSON.stringify(item);
                        this.hierarchyCopy = JSON.parse(hierarData);
                        item.IsShow = false;
                    }
                });
            }
            this.templateData = this.assignControl(controls, this.logInfo);
          
            this.templateData = await this.assignControlBySpNo(controls, this.spNo);
            this.listLoading = false;
            cols.forEach(async (item, index) => {
                if (item.Property.Title[0].Text.indexOf("数据填写") > -1) {
                    item.addIsShow = false;
                }
            });
        });
    },
    getTextVal() {
    },
    getSelectorVal: async function (val, name) {
        let isNull = "无";
        var that = this;
        var depts = [];
        //角色层级
        var hierarchys = [];
        let query = null;
        if (name == "secom") {
            this.fyVal = val.label;
            this.fyValKey = val.value;
            if (val.value === undefined) {
                return;
            }
            await getTemplateDetail(val.value).then((res) => {
                let cols = that.templateData.TemplateContent.Controls;
               
                cols.splice(17, cols.length - 17);
                let details = res.body.allocationDetails;
               
                details.forEach((detail, index) => {
                    if (detail.buildType !== "无") {
                        isNull = detail.buildType;
                    }
                    if (!depts.includes(detail.deptName)) {
                        depts.push(detail.deptName);
                    }
                });
                cols.forEach((item) => {
                    if (item.Property.Title[0].Text.indexOf("盘源类型") > -1) {
                        item.Value = isNull;
                        item.Disable = true;
                    }
                });
                depts.forEach((deptName) => {
                    this.deptCopy.Property.Title[0].Text = `${deptName}数据填写`;
                    let childrens = this.deptCopy.Config.Table.Children;
                    let chil = this.deptCopy.Config.Table.Children;
                    chil.forEach((c) => {
                        c.Value = null;
                        c.Values = null;
                        c.IsShow = true;
                    });
                    this.$set(this.deptCopy, "subCommission", true);
                    cols.push(this.deptCopy);
                    let deptData = JSON.stringify(this.deptCopy);
                    this.deptCopy = JSON.parse(deptData);
                });
                cols.forEach((item) => {
                    if (item.Property.Title[0].Text.indexOf("备注") > -1) {
                        item.IsShow = true;
                        let remarksData = JSON.stringify(item);
                        cols.push(JSON.parse(remarksData));
                        this.remarksCopy ="" ;
                        item.IsShow = false;
                        
                    }
                });
            });
        }
        else if (name == "secomNul") {
            this.fyVal = val.label;
            this.fyValKey = val.value;
            if (val.value === undefined) {
                return;
            }
            await getTemplateDetail(val.value).then((res) => {
                let cols = that.templateData.TemplateContent.Controls;
                let details = res.body.allocationDetails;
                details.forEach((detail, index) => {
                    if (detail.buildType !== "无") {
                        isNull = detail.buildType;
                    }
                    if (!depts.includes(detail.deptName)) {
                        depts.push(detail.deptName);
                    }
                });
                cols.forEach((item) => {
                    if (item.Property.Title[0].Text.indexOf("盘源类型") > -1) {
                        item.Value = isNull;
                        item.Disable = true;
                    }
                });
            });
        }
        this.templateData.TemplateContent.Controls.forEach((e) => {
            if (e.Property.Title[0].Text.indexOf("数据填写") > -1) {
                e.addIsShow = false;
            }
        });
    },
    tableOperation: function (val, type, datas) {
        if (type == "seno") {
            let dept = datas.Property.Title[0].Text;
            this.templateData.TemplateContent.Controls.forEach((e) => {
                if (e.Property.Title[0].Text == dept) {
                    let childs = e.Config.Table.Children;
                    childs.forEach((item) => {
                        if (item.Property.Title[0].Text == "员工工号") {
                            item.Value = val.value;
                        }
                        if (item.Property.Title[0].Text == "员工姓名") {
                            item.Value = val.value.split("-")[1];
                        }
                    });
                }
            });
        } else if (type == "exhibit") {
            let dept = datas.Property.Title[0].Text;
            this.templateData.TemplateContent.Controls.forEach((e) => {
                if (e.Property.Title[0].Text == dept) {
                    let childs = e.Config.Table.Children;
                    let empNo = "";
                    childs.forEach((item) => {
                        if (item.Property.Title[0].Text == "部门数据填写人") {
                            empNo = item.Value;
                        }
                        if (item.Property.Title[0].Text == "部门名称") {
                            let deptName = item.Value.split("/")[0];
                            item.Value = `${deptName}/${val.get(empNo)}`;
                        }
                    });
                }
            });
        } else if (type == "selectPeople") {
            var that = this;
            window.wx.invoke("selectEnterpriseContact",
            {
                beta: true,
                fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
                mode: "single", // 必填，选择模式，single表示单选，multi表示多选
                type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
                selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
                selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            },
            async function (res) {
                if (res.err_msg == "selectEnterpriseContact:ok") {
                    if (typeof res.result == "string") {
                        res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
                    }
                    var user = res.result.userList[0];
                    val.Values.push([user.id, user.name]);
                    val.Value = `${user.id}-${user.name}`;
                }
            });
        }
        else
        if (type == "selectDept") {
            var that = this;
            window.wx.invoke("selectEnterpriseContact",
            {
                beta: true,
                fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
                mode: "multi", // 必填，选择模式，single表示单选，multi表示多选
                type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
                selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
                selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            },
            async function (res) {
                if (res.err_msg == "selectEnterpriseContact:ok") {
                    if (typeof res.result == "string") {
                        res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
                    }
                    //多部门选择修改前
                    //var depart = res.result.departmentList[0];
                    //val.Values.push([depart.id, depart.name]);
                    //val.Value = `${depart.name}`;
                    let departNames = "";
                    for (var depart of res.result.departmentList) {
                        val.Values.push([depart.id, depart.name]);
                        if (departNames != "") {
                            departNames += "-";
                        }
                        departNames += `${depart.name}`;
                    }
                    val.Value = departNames;
                }
                
            });

        }else {
            if (type == "add") {
                type = "addAndVal";
            }
            if (type == "delete") {
                type = "delAndVal";
            }
            this.tableoperation(val, type, datas, this);
        }
    },
    submit: function () {
        this.isDisabled = true
        let that = this;
        var data = {
            //填充状态
            FillStatus: 0,
            //项目名称
            ProjectName: "",
            //类别
            ProjectType: "",
            //以后销售佣金中抵扣
            LaterCommissionDeduction: false,
            //开发商名称
            DevelopersName: "",
            //对外分佣(元)
            ExternalCommission: "",
            //转介费(元)
            ReferralFee: "",
            //成交编号
            ContractNo: "",
            //盘源类型
            BuildType: "",
            //代理
            AgencyType: "",
            //品牌顾问策划项目
            BrandConsultantPlanningProject: false,
            //计佣区域
            CommissionArea: "",
            //申请变更日期
            ApplyChangeDate: "",
            //分佣比例类型
            CommissionRateType: "",
            //分佣比例id
            CommissionRateTypeId: "",
            Remarks: "",
            HeaderExtensions: [],
            ProjectApproval: null,
            Id: that.id
        };
        let cols = that.templateData.TemplateContent.Controls;
        //数据校验
        if (!this.submitValidate(cols)) {
            this.isDisabled = false
            return;
        }
        
        let dets = [];
        let detPers = [];
        cols.forEach((col) => {
            if (col.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
                data.CommissionRateType = col.value.Value;
                data.CommissionRateTypeId = col.value.Key;
                col.Property.Control = "Text";
                col.filterable = false;
                col.Value = data.CommissionRateType;
                delete col.value
            }
            if (col.Property.Title[0].Text.indexOf("项目名称") > -1) {
                data.ProjectName = col.Value;
            }
            if (col.Property.Title[0].Text.indexOf("请选择营运部总经理") > -1) {
                data.ProjectApproval = {
                    Key: col.Value.split("-")[0],
                    Value: col.Value.split("-")[1],
                };
            }
            if (col.Property.Title[0].Text.indexOf("类别") > -1) {
                col.Config.Selector.Options.forEach((option) => {
                    if (col.Value == option.Key) {
                        data.ProjectType = option.Value[0].Text;
                    }
                });
            }
            if (col.Property.Title[0].Text.indexOf("开发商名称") > -1) {
                data.DevelopersName = col.Value;
                if (col.Value === null) {
                    data.DevelopersName = "";
                }
            }
            if (col.Property.Title[0].Text.indexOf("对外分佣") > -1) {
                data.ExternalCommission = col.Value;
                if (col.Value === null) {
                    data.ExternalCommission = "";
                }
            }
            if (col.Property.Title[0].Text.indexOf("转介费") > -1) {
                data.ReferralFee = col.Value;
                if (col.Value === null) {
                    data.ReferralFee = "";
                }
            }
            if (col.Property.Title[0].Text.indexOf("成交编号") > -1) {
                data.ContractNo = col.Value;
                if (col.Value === null) {
                    data.ContractNo = "";
                }
            }
            if (col.Property.Title[0].Text.indexOf("盘源类型") > -1) {
                data.BuildType = col.Value === "无" || col.Value === null ? "" : col.Value;
            }
            if (col.Property.Title[0].Text.indexOf("代理类型") > -1) {
                if (col.Value === null) {
                    data.AgencyType = "";
                } else {
                    col.Config.Selector.Options.forEach((option) => {
                        if (col.Value == option.Key) {
                            data.AgencyType = option.Value[0].Text;
                        }
                    });
                }
            }
            if (col.Property.Title[0].Text.indexOf("是否在以后销售佣金中抵扣") > -1) {
                if (col.Value === null) {
                    data.LaterCommissionDeduction = null;
                } else {
                    let options = col.Config.Selector.Options;
                    options.forEach((option) => {
                        if (option.Key == col.Value) {
                            data.LaterCommissionDeduction = option.Value[0].Text == "是";
                        }
                    });
                }
            }
            if (col.Property.Title[0].Text.indexOf("品牌顾问策划项目") > -1) {
                let options = col.Config.Selector.Options;
                if (col.Value === null) {
                    data.BrandConsultantPlanningProject = null;
                } else {
                    options.forEach((option) => {
                        if (option.Key == col.Value) {
                            data.BrandConsultantPlanningProject = option.Value[0].Text == "是";
                        }
                    });
                }
            }
            if (col.Property.Title[0].Text.indexOf("计佣区域") > -1) {
                if (col.Value === null) {
                    data.CommissionArea = "";
                } else {
                    col.Config.Selector.Options.forEach((option) => {
                        if (col.Value == option.Key) {
                            data.CommissionArea = option.Value[0].Text;
                        }
                    });
                }
            }
            if (col.Property.Title[0].Text.indexOf("备注") > -1) {
                data.Remarks = col.Value;
                if (col.Value === null) {
                    data.Remarks = "";
                }
            }
            if (col.Property.Title[0].Text.indexOf("申请变更日期") > -1) {
                data.ApplyChangeDate = col.Value;
            }
            //数据填写
            if (col.Property.Title[0].Text.indexOf("数据填写") > -1) {
                let childrens = col.Config.Table.Children;
                let ind = col.Property.Title[0].Text.split("数据填写")[0];
                var mydept = null;
                childrens = childrens.reverse();
                for (const item of childrens) {
                    if (item.Property.Title[0].Text.indexOf("部门名称") > -1) {
                        item.Disable = true;
                        if (that.id == null){
                          for (var value of item.Values) {
                            dets.push(value[1]+`/${ind}`);
                          }
                        }else{
                          dets.push(`${item.Value}/${ind}`);
                        }
                        mydept = `${item.Value}/${ind}`;
                    }
                    if (item.Property.Title[0].Text.indexOf("部门数据填写人") > -1) {
                        item.Property.Control = "Text";
                        item.filterable = false;
                        item.Disable = true;
                        if (mydept != null && mydept != "") {
                            detPers.push({
                                Key: mydept,
                                Value: item.Value,
                            });
                        }
                    }
                }
              childrens = childrens.reverse();
            }
        });
        let peoples = []
        detPers.forEach(item => peoples.push(item.Value))
        dets.forEach((item) => {
            data.HeaderExtensions.push({
                Key: item.split("/")[1],
                Value: item.split("/")[0],
                IsMark: true,
            });
        });
        detPers.forEach((item) => {
            data.HeaderExtensions.push({
                Key: `${item.Key.split("/")[1]}填写人`,
                Value: item.Value,
                IsMark: false,
            });
        });
        let a = true;
        if (this.isRepeat(peoples)) {
          this.Message({
            message: "不能出现类同的数据填写人",
            type: "error",
            duration: 3 * 1000,
          });
          this.isDisabled = false
          cols.forEach((col) => {
            if (col.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
              col.Property.Control = "Selector";
              col.filterable = true;
              this.$set(col, 'value', {
                "Key": data.CommissionRateTypeId,
                "Value": data.CommissionRateType
              })
            }
          });
          return
        }

        getAllocationTableHeaderDto(data).then((res) => {
            if (res.errCode == 4) {
                this.Message({
                    message: "同一项目名称不能多次变更",
                    type: "error",
                    duration: 3 * 1000
                });
                this.isDisabled = false
                cols.forEach((col) => {
                    if (col.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
                        col.Property.Control = "Selector";
                        col.filterable = true;
                        this.$set(col, 'value', {
                            "Key": data.CommissionRateTypeId,
                            "Value": data.CommissionRateType
                        })
                    }
                });
                return
            }
            this.Message({
                message: "申请成功",
                type: "success",
                duration: 3 * 1000,
            });
            setTimeout(() => {
                this.$router.push("/index");
            }, 3000);
        }).catch(e => {
            cols.forEach((col) => {
                this.isDisabled = false
                if (col.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
                    col.Property.Control = "Selector";
                    col.filterable = true;
                    this.$set(col, 'value', {
                        "Key": data.CommissionRateTypeId,
                        "Value": data.CommissionRateType
                    })
                }
            });
        })
    },
  },
  watch: {
    relationList(val, oldVal) {
      if (oldVal == null) {
        this.getTemplate();
      }
    },
  },
};
</script>

<style scoped lang="less">
.pages {
  padding-bottom: 14px;
}
</style>
